export class SetBranding {
  public static readonly type = '[Branding] Set';
  constructor(public payload: string) {}
}
